var map = {
	"./android-chrome-192x192": 14,
	"./android-chrome-192x192.png": 14,
	"./android-chrome-512x512": 15,
	"./android-chrome-512x512.png": 15,
	"./apple-touch-icon": 16,
	"./apple-touch-icon.png": 16,
	"./confirm": 17,
	"./confirm.svg": 17,
	"./favicon": 18,
	"./favicon.ico": 18,
	"./heart": 2,
	"./heart.png": 2,
	"./heart.webp": 201,
	"./icon": 19,
	"./icon.svg": 19,
	"./icons/shevron": 20,
	"./icons/shevron.svg": 20,
	"./icons/sprite": 21,
	"./icons/sprite.svg": 21,
	"./logo_new_year": 22,
	"./logo_new_year.svg": 22,
	"./main-bg": 3,
	"./main-bg.jpg": 3,
	"./main-bg.webp": 202,
	"./main-bg1": 4,
	"./main-bg1.jpg": 4,
	"./main-bg1.webp": 203,
	"./manifest": 23,
	"./manifest.webmanifest": 23,
	"./operators": 24,
	"./operators.svg": 24,
	"./payment/ApplePay": 25,
	"./payment/ApplePay.svg": 25,
	"./payment/alfabank-logo": 26,
	"./payment/alfabank-logo-min": 27,
	"./payment/alfabank-logo-min.svg": 27,
	"./payment/alfabank-logo.svg": 26,
	"./payment/cloudpayments": 28,
	"./payment/cloudpayments.svg": 28,
	"./payment/dollar": 29,
	"./payment/dollar.svg": 29,
	"./payment/euro": 30,
	"./payment/euro.svg": 30,
	"./payment/gpay": 31,
	"./payment/gpay.svg": 31,
	"./payment/phone": 5,
	"./payment/phone.png": 5,
	"./payment/phone.svg": 204,
	"./payment/qiwi-logo": 32,
	"./payment/qiwi-logo.svg": 32,
	"./payment/ruble": 33,
	"./payment/ruble.svg": 33,
	"./payment/sber-button-g-b": 34,
	"./payment/sber-button-g-b.svg": 34,
	"./payment/sberbank-biz-logo-min": 35,
	"./payment/sberbank-biz-logo-min.svg": 35,
	"./payment/sberbank-logo": 36,
	"./payment/sberbank-logo-min": 37,
	"./payment/sberbank-logo-min.svg": 37,
	"./payment/sberbank-logo.svg": 36,
	"./payment/sberbank-new-logo": 38,
	"./payment/sberbank-new-logo.svg": 38,
	"./payment/sbp": 39,
	"./payment/sbp.svg": 39,
	"./payment/tinkoff-logo": 40,
	"./payment/tinkoff-logo-min": 41,
	"./payment/tinkoff-logo-min.svg": 41,
	"./payment/tinkoff-logo.svg": 40,
	"./payment/tochkabank-logo": 42,
	"./payment/tochkabank-logo.svg": 42,
	"./payment/visa-logo": 43,
	"./payment/visa-logo-icon": 44,
	"./payment/visa-logo-icon.svg": 44,
	"./payment/visa-logo.svg": 43,
	"./payment/webmoney-logo": 45,
	"./payment/webmoney-logo.svg": 45,
	"./payment/yandex-logo": 46,
	"./payment/yandex-logo-min": 47,
	"./payment/yandex-logo-min.svg": 47,
	"./payment/yandex-logo.svg": 46,
	"./pechat": 48,
	"./pechat.png": 48,
	"./phone_hand": 49,
	"./phone_hand.svg": 49,
	"./podpis": 50,
	"./podpis.png": 50,
	"./popup-heart": 6,
	"./popup-heart-slide": 51,
	"./popup-heart-slide.png": 51,
	"./popup-heart.png": 6,
	"./popup-heart.webp": 205,
	"./promo-slide-bg": 7,
	"./promo-slide-bg.png": 7,
	"./promo-slide-bg.webp": 206,
	"./promo-slide-image": 8,
	"./promo-slide-image.png": 8,
	"./promo-slide-image.webp": 207,
	"./rutube_icon": 52,
	"./rutube_icon.svg": 52,
	"./saveme_qr_sber": 53,
	"./saveme_qr_sber.png": 53,
	"./saveme_qr_sbp": 54,
	"./saveme_qr_sbp.png": 54,
	"./saveme_qr_tinkoff": 55,
	"./saveme_qr_tinkoff.png": 55,
	"./sberbank_logo": 56,
	"./sberbank_logo.svg": 56,
	"./scan": 9,
	"./scan.jpg": 9,
	"./scan.webp": 208,
	"./success": 57,
	"./success.svg": 57,
	"./text-card-image": 10,
	"./text-card-image.jpg": 10,
	"./text-card-image.webp": 209,
	"./tinkoff_logo": 58,
	"./tinkoff_logo.svg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;